module.exports = __webpack_public_path__ + "img/food_drink.74201202.png";